import { OnInit, Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { ReservationService } from '../../../services/reservation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterService } from '../../../services/filter.service';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { EquipmentFilter } from '../../../model/equipment-filter';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EquipmentPhysisicianChange } from '../../../model/equipment-physisician-change';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';

@Component({
  selector: 'change-equipment-physician-dialog',
  templateUrl: 'change-equipment-physician-dialog.component.html',
  styleUrls: ['./change-equipment-physician-dialog.component.css']
})
export class ChangeEquipmentPhysicianDialogComponent implements OnInit {

  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private reservationService: ReservationService
    , private filterService: FilterService
    , private confirmDialogService: ConfirmDialogService
    , public dialogRef: MatDialogRef<ChangeEquipmentPhysicianDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      Physician: [''],
      Equipment: [''],
      MedicalAppointmentIds: [this.data.medicalAppointmentIds],
    });

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>([], this.form.controls.Equipment);
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([], this.form.controls.Physician);
  }

  get filteredEquipmentsOptions() { return this.filterCompleteEquipments ? this.filterCompleteEquipments.filteredOptions : []; }
  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ? this.filterCompletePhysicians.filteredOptions : []; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>((await this.filterService.getPhysiciansFilter()), this.form.controls.Physician);
    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>((await this.filterService.getEquipmentsFilter()), this.form.controls.Equipment);
  }

  async save() {
    const equipmentPhysisicianChange = <EquipmentPhysisicianChange>this.form.getRawValue();
    if (equipmentPhysisicianChange.Equipment || equipmentPhysisicianChange.Physician) {
      this.confirmDialogService.confirm('Reemplazo de equipo y médico'
        , 'Si el médico seleccionado no realiza alguna de las prácticas o el equipo seleccionado no pertenece al mismo servicio, no se aplicará el cambio. Desea continuar?')
        .subscribe((result) => {
          if (result) {
            this.reservationService.changeReservationEquipmentPhysician(equipmentPhysisicianChange).then((ret) => {
              if (ret) {
                this.notificationToastService.success('Se ha finalizado el reemplazo', 'Reemplazo de equipo y médico');
                this.dialogRef.close(true);
              }
            }).catch((err) => {
              this.notificationToastService.error(JSON.stringify(err.error), 'Reemplazo de equipo y médico');
            });
          }
        });
    }
  }
}
